import * as React from "react";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

interface CustomizedSwitchesProps {
	checked: boolean;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	label: string;
}

const Android12Switch = styled(Switch)(({ theme }) => ({
	padding: 8,
	"& .MuiSwitch-track": {
		borderRadius: 11,
		"&::before, &::after": {
			// eslint-disable-next-line quotes
			content: '""',
			position: "absolute",
			top: "50%",
			transform: "translateY(-50%)",
			width: 16,
			height: 16
		},
		"&::before": {
			backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' height='16' width='16' viewBox='0 0 24 24'><path fill='${encodeURIComponent(
				theme.palette.getContrastText(theme.palette.primary.main)
			)}' d='M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z'/></svg>")`,
			left: 12
		},
		"&::after": {
			backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' height='16' width='16' viewBox='0 0 24 24'><path fill='${encodeURIComponent(
				theme.palette.getContrastText(theme.palette.primary.main)
			)}' d='M19,13H5V11H19V13Z' /></svg>")`,
			right: 12
		}
	},
	"& .MuiSwitch-thumb": {
		boxShadow: "none",
		width: 16,
		height: 16,
		margin: 2
	}
}));

const CustomizedSwitches: React.FC<CustomizedSwitchesProps> = ({ checked, onChange, label }) => {
	return (
		<FormGroup>
			<FormControlLabel
				control={<Android12Switch checked={checked} onChange={onChange} color="success" />}
				label={label}
			/>
		</FormGroup>
	);
};

export default CustomizedSwitches;
